import React, { useEffect, useState } from "react";
import avatar from "../assets/images/Avatar-1.png";
import userRound from "../assets/images/user-Round.png";
import gmail from "../assets/images/gmail.png";
import location from "../assets/images/location.png";
import PhoneRotatry from "../assets/images/phone-rotary.png";
import { imageUpload } from "../features/slices/liveStream";
import { toastService } from "../utils/toastify";
import { useDispatch } from "react-redux";
import { updateProfile, viewProfile } from "../features/slices/authReducer";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
const initialState = {
  name: "",
  email: "",
  phoneNumber: "",
  address: "",
  profilePic: "",
  errors: {},
  imageLoader: false,
};
const Profile = () => {
  const [iState, setUpdateState] = useState(initialState);
  const { name, email, phoneNumber, address, profilePic, errors, imageLoader } =
    iState;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { profileData } = useSelector((state) => {
    return state?.auth;
  });

  useEffect(() => {
    dispatch(viewProfile());
  }, [dispatch]);
  useEffect(() => {
    setUpdateState((prev) => ({
      ...prev,
      name: profileData?.activeUser?.name || "",
      email: profileData?.activeUser?.email || "",
      phoneNumber: profileData?.activeUser?.phoneNumber || "",
      address: profileData?.activeUser?.address || "",
      profilePic: profileData?.activeUser?.profilePic || "",
    }));
  }, [profileData]);
  const validateForm = () => {
    let formErrors = {};
    let isValid = true;
    if (!name?.trim()) {
      formErrors.name = "Full name is required.";
      isValid = false;
    }
    if (!email?.trim()) {
      formErrors.email = "Email is required.";
      isValid = false;
    }
    if (phoneNumber?.length < 10) {
      formErrors.phoneNumber = "Phone number must be at least 10 digits";
      isValid = false;
    }
    if (!phoneNumber?.trim()) {
      formErrors.phoneNumber = "Phone number is required.";
      isValid = false;
    }

    // if (!address?.trim()) {
    //   formErrors.address = "Address is required.";
    //   isValid = false;
    // }
    // if (!profilePic?.trim()) {
    //   formErrors.profilePic = "Profile profilePic is required.";
    //   isValid = false;
    // }
    setUpdateState((prev) => ({ ...prev, errors: formErrors }));
    return isValid;
  };
  const handleImage = (e) => {
    console.log({ e });

    setUpdateState((prev) => ({
      ...prev,
      imageLoader: true,
      errors: {
        ...prev.errors,
        [e.target.name]: "",
      },
    }));
    const file = e.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("fileName", file);
      dispatch(imageUpload(formData)).then((res) => {
        if (res?.payload?.code == 200) {
          console.log(res);

          toastService.success("Image uploaded successfully");
          setUpdateState((prev) => ({
            ...prev,
            profilePic: res?.payload?.url,
            imageLoader: false,
          }));
        } else {
          toastService.error("Failed to upload");
          setUpdateState((prev) => ({
            ...prev,
            profilePic: "",
            imageLoader: false,
          }));
        }
      });
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUpdateState((prev) => ({
      ...prev,
      errors: {
        ...prev.errors,
        [e.target.name]: "",
      },
    }));
    setUpdateState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleSubmit = () => {
    const data = { name, email, phoneNumber, address, profilePic };
    if (validateForm()) {
      dispatch(updateProfile(data)).then((res) => {
        if (res?.payload?.code == 200) {
          dispatch(viewProfile());
          toastService.success("Profile updated successfully");
        } else {
          toastService.error("Failed to update profile");
        }
      });
    }
  };
  const handleCancel = () => {
    setUpdateState(initialState);
    navigate(-1);
  };
  const handleDelete = () => {
    setUpdateState((prev) => ({
      ...prev,
      profilePic: "",
    }));
    const data = { name, email, phoneNumber, address, profilePic: "" };
    dispatch(updateProfile(data)).then((res) => {
      if (res?.payload?.code == 200) {
         dispatch(viewProfile());
        toastService.success("Profile picture deleted successfully");
      } else {
        toastService.error("Failed to delete profile picture");
      }
    });
  };
  return (
    <div className="WrapperArea">
      <div className="WrapperBox">
        <div className="Small-Wrapper">
          <div className="TitleBox Border">
            <h4 className="Title">General Settings</h4>
          </div>
          <div className="CommonForm">
            <div className="UserBody">
              <figure>
                <img
                  src={profilePic || avatar}
                  style={{
                    width: "100px",
                    height: "100px",
                    borderRadius: "100%",
                  }}
                />
              </figure>
              <figcaption>
                <p>We only support .JPG, .JPEG, or .PNG file.</p>
                <div className="UploadPhoto">
                  <input
                    type="file"
                    name="profilePic"
                    accept=".png,.jpg,.jpeg"
                    // value={image}
                    onChange={handleImage}
                  />
                  <span>Upload photo</span>
                </div>
                <button
                  className="Button DeletePhoto"
                  disabled={!profilePic}
                  onClick={handleDelete}
                >
                  Delete Photo
                </button>
              </figcaption>
            </div>
            {errors.profilePic && (
              <p
                className="d-flex justify-content-start text-danger mt-2 "
                style={{
                  fontSize: "13px",
                }}
              >
                {errors.profilePic}
              </p>
            )}
            <div className="form-group">
              <label>Full Name</label>
              <div className="SearchBox">
                <input
                  type="search"
                  className="SearchInput"
                  placeholder="Enter full name"
                  name="name"
                  value={name}
                  onChange={handleChange}
                />
                <span>
                  <img src={userRound} />
                </span>
              </div>
              {errors.name && (
                <p className="d-flex justify-content-start text-danger mt-2 ">
                  {errors.name}
                </p>
              )}
            </div>
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Email</label>
                  <div className="SearchBox">
                    <input
                      type="email"
                      className="SearchInput"
                      placeholder="Enter email id"
                      name="email"
                      value={email}
                      onChange={handleChange}
                      disabled
                    />
                    <span>
                      <img src={gmail} />
                    </span>
                  </div>
                  {errors.email && (
                    <p className="d-flex justify-content-start text-danger mt-2 ">
                      {errors.email}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Phone Number</label>
                  <div className="SearchBox">
                    <input
                      type="number"
                      className="SearchInput"
                      placeholder="Enter phoneNumber number"
                      name="phoneNumber"
                      maxLength={10}
                      value={phoneNumber}
                      onChange={handleChange}
                      onInput={(e) => {
                        if (e.target.value.length > 10) {
                          e.target.value = e.target.value.slice(0, 10); // Restrict to 10 digits
                        }
                      }}
                    />
                    <span>
                      <img src={PhoneRotatry} />
                    </span>
                  </div>
                  {errors.phoneNumber && (
                    <p className="d-flex justify-content-start text-danger mt-2 ">
                      {errors.phoneNumber}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* <div className="TitleBox Border">
            <h4 className="Title">Personal Address</h4>
          </div> */}
          {/* <div className="CommonForm">
            <div className="form-group">
              <label>Address</label>
              <div className="SearchBox">
                <input
                  type="search"
                  className="SearchInput"
                  placeholder="Enter address"
                  name="address"
                  value={address}
                  onChange={handleChange}
                />
                <span>
                  <img src={location} />
                </span>
              </div>
              {errors.address && (
                <p className="d-flex justify-content-start text-danger mt-2 ">
                  {errors.address}
                </p>
              )}
            </div>
          </div> */}
          <button className="Button" onClick={handleSubmit}>
            Save Details
          </button>
          <button className="Button Discard border-0" onClick={handleCancel}>
            {" "}
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default Profile;
